import { Component, Inject, OnInit } from '@angular/core';
import { ActionsSubject } from '@ngrx/store';
import { SubSink } from 'subsink';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  private readonly subs = new SubSink();
  private readonly _actionsSubject: ActionsSubject;
  message :any;
  cancelButtonText = "Cancel"
  inited: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly dialogRef: MatDialogRef<ModalComponent>) {
      this.message = {
        data:{},
        buttons: [],
        template: undefined,
        style: {}
      }
    if (data) {
      if (data.message?.template) {
        this.message.template = data.message.template;
      }
      if(data.message?.style){
        this.message.style = data.message.style;
      }
    }
    this.dialogRef.updateSize('300vw','300vw')
  }
  ngOnInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      this.inited = true;
    })
    
    let table: any;
    const overlayPane = document.getElementsByClassName('cdk-overlay-pane')[0];
    if (overlayPane) {
      table = overlayPane;
    }

    if(this.message?.style && Object.keys(this.message.style).length > 0){
      for (let i in this.message.style){
        table.setAttribute('style',`${i}:${this.message.style[i]}`);
      }
    }
    
    const dialogContainer = document.getElementsByClassName('mat-dialog-container')[0];
    if (dialogContainer) {
      dialogContainer.setAttribute('style', 'padding: 0px');
    }
    
  }

  
  closeModal(): void {
    this.dialogRef.close(true);
  }

}
